import React from 'react';
import DashboardComponent from "@/components/dashboard/Dashboard";

const Dashboard = () => {
  return (
      <DashboardComponent onLogout={() => {}} />
  );
};

export default Dashboard;